const CLAIM_KEY = 'dobi.referral-claim-receipt';
const CLAIM_TTL_MS = 15 * 60 * 1000;

export interface PendingReferralClaim { code: string; expiresAt: number; userId?: string; }

/** 只在登录表单保存领取意图，不存登录凭据，也不把它当作到账证明。 */
export function rememberReferralClaim(code: string, userId?: string): void {
  if (typeof window === 'undefined') return;
  try {
    if (!code.trim()) { window.sessionStorage.removeItem(CLAIM_KEY); return; }
    window.sessionStorage.setItem(CLAIM_KEY, JSON.stringify({ code: code.trim().toUpperCase(), expiresAt: Date.now() + CLAIM_TTL_MS, userId }));
  } catch { /* 不支持 sessionStorage 时仍允许登录。 */ }
}

export function loadPendingReferralClaim(): PendingReferralClaim | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = JSON.parse(window.sessionStorage.getItem(CLAIM_KEY) || 'null') as PendingReferralClaim | null;
    if (!value || typeof value.code !== 'string' || !value.code || !Number.isFinite(value.expiresAt) || value.expiresAt <= Date.now()) return null;
    return value;
  } catch { return null; }
}

export function clearPendingReferralClaim(): void {
  if (typeof window === 'undefined') return;
  try { window.sessionStorage.removeItem(CLAIM_KEY); } catch { /* 存储受限时不影响画布。 */ }
}
